import { action, makeObservable, observable } from "mobx";
import { v4 } from 'uuid';
import { VariationStore } from "./variation";

export class VariationTypeStore {
    @observable id;
    @observable title = '';
    @observable isPrimary = false;
    variations;

    constructor(variationType, isPrimary) {
        makeObservable(this);
        if (variationType) {
            this.id = variationType.id;
            this.setIsPrimary(variationType.isPrimary);
            this.setTitle(variationType.title);
            this.variations = observable.array(variationType.variations.map(data => new VariationStore(data)));
        } else {
            this.id = v4();
            this.variations = observable.array();
            this.isPrimary = isPrimary;
        }
    }

    @action.bound setTitle = (title) => this.title = title;
    @action.bound setIsPrimary = (isPrimary) => this.isPrimary = isPrimary;
    @action.bound removeVariation = (id) => this.variations.splice(this.variations.findIndex(v => v.id === id), 1);

    @action.bound addVariation = (variation) => {
        const variationToAdd = new VariationStore(variation);
        this.variations.push(variationToAdd);
        return variationToAdd;
    }
}
